import useScreenSize from '@/hooks/useScreenSize';

import { ErrorBoundary } from '@/components/common/CatchErrorComponent';
import { PageBlockStyles } from '@/components/common/Providers/GraphqlProvider/generated';
import { Typography } from '@/components/ui/Typography';

import { usePressRoomContext } from '../../../views/providers/PressRoomContext';
import NewsSocialMedia from '../../PageNewsletterBlock/public2/components/NewsSocialMedia';

export type BlockStyle = {
  isA: boolean;
  isB: boolean;
  isC: boolean;
};

export type PressroomBlockStyle = {
  header: BlockStyle;
  news: BlockStyle;
  tags: BlockStyle;
  sns: BlockStyle;
};

const PressRoomSocialNetworks = () => {
  const { snsBlock, showSnsBlock } = usePressRoomContext();
  const { isScreenLargerThan } = useScreenSize();

  const pressroomBlockStyle: PressroomBlockStyle = {
    header: {
      isA: false,
      isB: false,
      isC: false,
    },
    news: {
      isA: false,
      isB: false,
      isC: false,
    },
    tags: {
      isA: false,
      isB: false,
      isC: false,
    },
    sns: {
      isA: !snsBlock || !snsBlock.pageBlockStyle || snsBlock.pageBlockStyle === PageBlockStyles.A,
      isB: snsBlock?.pageBlockStyle === PageBlockStyles.B,
      isC: snsBlock?.pageBlockStyle === PageBlockStyles.C,
    },
  };

  if (!snsBlock?.items || (isScreenLargerThan && !showSnsBlock)) return null;

  return (
    <ErrorBoundary fallback={'Oops, hubo un error'}>
      <div className="mb-[100px] flex flex-col gap-[30px]">
        {snsBlock.showTitle && (
          <Typography variant={'h3'} className="text-[32px]">
            {snsBlock.blockTitle || 'Nuestras redes'}
          </Typography>
        )}

        {snsBlock.showDescription && <p>{snsBlock.publicDescription}</p>}
        <NewsSocialMedia
          items={snsBlock.items.map((e) => ({
            id: e.id,
            link: e.itemLink?.url,
            snsSocialNetworkType: e.snsSocialNetworkType,
          }))}
          blockStyle={pressroomBlockStyle.sns}
        />
      </div>
    </ErrorBoundary>
  );
};

export default PressRoomSocialNetworks;
